import { useMutation } from '@tanstack/react-query';
import { useCallback, useRef } from 'react';
import { userService } from '../../services/userService';

const DEBOUNCE_DELAY = 500;

export const useSubmitPhoneVerifyCode = () => {
  const timerRef = useRef(null);
  const mutationRef = useRef(null);

  const mutation = useMutation({
    mutationFn: payload =>
      userService.phoneVerifySubmitCode(payload).then(response => {
        const { status, data } = response;
        if (status === 200) {

          return { success: true, data };
        }

        if (status === 422) {
          return { message: data.message }
        }

        return { message: 'Something went wrong' };
      }),
  });

  mutationRef.current = mutation;

  const debouncedMutateAsync = useCallback(
    payload =>
      new Promise((resolve, reject) => {
        clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => {
          mutationRef.current.mutateAsync(payload).then(resolve).catch(reject);
        }, DEBOUNCE_DELAY);
      }),
    [],
  );

  return { ...mutation, mutateAsync: debouncedMutateAsync };
};
